export const formatTaxNumber = (taxNumber: string | undefined) => {
  if (!taxNumber) return "";
  const match = taxNumber.match(/^(\d{8})(\d{1})(\d{2})$/);
  if (!match) return taxNumber;
  return `${match[1]}-${match[2]}-${match[3]}`;
};

export default formatTaxNumber;
